export default {
  OUTPUT_FIELD_DEFINITION: 'outputFieldDefinition',
  TYPE_DEFINITION: 'typeDefinition',
  UPDATE_TYPE: 'updateType',
  NAME: 'name'
};